var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"page","element-loading-text":_vm.$t('confirm.generating_pdf')}},[(!_vm.loading)?_c('div',{staticClass:"success-message"},[_c('p',[_vm._v(_vm._s(_vm.$t('confirm.pdf_generated_success')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }